<template>
  <div>
    <div v-for="option in question.options" v-bind:key="option.id">
      <label>
        <input
          type="radio"
          :checked="question.answer.value === option.choice ? true : false"
          :value="option.choice"
          :name="name"
          :id="question.answer.id"
          :categoryId="categoryId"
          @change="answer.value = option.choice">
      {{option.choice}}</label>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    question: Object,
    categoryId: Number
  },
  data(){
    return{
      name: `radioQuestion${this.$props.question.id}`,
      answer: this.$props.question.answer
    }
  }
}
</script>

<style>

</style>
